import {
  addOptionalToSchema,
  pastDateSchema,
  dateSchema,
  requiredErrorMessage,
  textSchema,
  addOptionalNullableToSchema,
} from '@common/schema';
import * as yup from 'yup';
import { ChangeProgramStatus, UnalignmentReason } from '@common/types';

export const buildEditProgramSchema = (
  requireTier: boolean,
  requireRespiteEligibility: boolean,
) =>
  yup.object().shape({
    new_status: yup.mixed<ChangeProgramStatus>().required(requiredErrorMessage),

    tier: textSchema.when('new_status', ([new_status], schema) =>
      new_status === 'Aligned' && requireTier
        ? schema.required(requiredErrorMessage)
        : addOptionalToSchema(schema),
    ),

    respite_eligible: yup
      .string()
      .oneOf(['Unknown', 'Eligible', 'Ineligible'])
      .when('new_status', ([new_status], schema) =>
        new_status === 'Aligned' && requireRespiteEligibility
          ? schema.required(requiredErrorMessage)
          : addOptionalToSchema(schema),
      ),
    respite_ineligibility_reason: yup
      .string()
      .oneOf(['Due to the tier', 'Due to FAST score', 'No ZBI Information'])
      .when('respite_eligible', ([respite_eligible], schema) =>
        respite_eligible === 'Ineligible'
          ? schema.required(requiredErrorMessage)
          : addOptionalNullableToSchema(schema),
      ),
    alignment_date: dateSchema.when('new_status', ([new_status], schema) =>
      new_status === 'Aligned'
        ? schema.required(requiredErrorMessage)
        : schema.optional(),
    ),
    alignment_notification_date: pastDateSchema.when(
      'new_status',
      ([new_status], schema) =>
        new_status === 'Aligned'
          ? schema.required(requiredErrorMessage)
          : schema.optional(),
    ),
    rejection_reason: textSchema.when('new_status', ([new_status], schema) =>
      new_status === 'Rejected' || new_status === 'Resubmission rejected'
        ? schema.required(requiredErrorMessage)
        : addOptionalToSchema(schema),
    ),
    unalignment_reason: yup
      .mixed<Exclude<UnalignmentReason, undefined>>()
      .when('new_status', ([new_status], schema) =>
        new_status === 'Unaligned' || new_status === 'To be unaligned'
          ? schema.required(requiredErrorMessage)
          : addOptionalToSchema(schema),
      ),
    unalignment_date: pastDateSchema.when(
      'new_status',
      ([new_status], schema) =>
        new_status === 'Unaligned' || new_status === 'To be unaligned'
          ? schema.required(requiredErrorMessage)
          : schema.optional(),
    ),
  });

export const formShapeSchema = buildEditProgramSchema(false, false);
